import classNames from "classnames";
import { GroupIcon } from "../../groupIcon/groupIcon";
import styles from "./featureRow.module.scss";
import {Tag} from "antd";
import {Circle} from "../../../../../../common/components/circle/circle";

export const FeatureRow = ({
  group,
  count,
  total,
  status,
  active,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={classNames(styles.featureRow, {
        [styles.featureRow_active]: active,
      })}
      onClick={onClick}
    >
      <GroupIcon icon={group.icon} className={styles.featureRow__icon} />
      <span className={styles.featureRow__name}>{group.name}</span>
      <Tag
        className={classNames(styles.featureRow__chip, "mr-0") }
        icon={ status === 'some' ? <Circle color="var(--primary-color)" />
              : status === 'warn' ?  <Circle color="var(--warning-color)" />
              : <Circle color="var(--gray-200)" />
            }
      >
        {count}/{total}
      </Tag>
    </button>
  );
};
